








































































































































import IconButton from "@/components/IconButton.vue";
import Vue from "vue";
import CheckBox from "@/components/CheckBox.vue";
import flowStore, { InvoiceFlowStore } from "@/modules/invoiceFlow/services/InvoiceFlowStore";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import * as api from "../../canNet/services/CarNetApi";
import itemStore, { InvoiceItemStore } from "@/modules/invoiceItems/services/store";
import { OtherItem } from "../models";
import { t } from "@/plugins/i18n";

interface Data {
  flowStore: InvoiceFlowStore;
  itemStore: InvoiceItemStore;
  newCarRectItemRelations: any[];
  carRectItemRelation: any;
  searchText: string;
  selectedCarRectItem: any;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: { IconButton, MoneyDisplay, CheckBox },
  props: {
    invItemId: Number,
    invItemGpartId: Number,
    invItemNetto: Number,
    isPageDisabled: Boolean,
  },

  data() {
    return {
      flowStore,
      itemStore,
      newCarRectItemRelations: [],
      carRectItemRelation: {},
      searchText: "",

      selectedCarRectItem: undefined,
    };
  },

  async beforeMount() {
    this.selectedCarRectItem = await api.getCurrentCarRectItemRelation(Number(this.$props.invItemId));
  },

  methods: {
    addGeneralCarRectItem() {
      const item = this.itemStore.itemList.items.find((x) => x.invoiceItemID == this.$props.invItemId);
      if (item != null) {
        item.isGeneralRectItem = true;
        item.generalRectItemDetails.id = 0;
        item.generalRectItemDetails.item = this.$props.invItemId;
        item.generalRectItemDetails.invoice = this.flowStore.invoice.id;
        item.generalRectItemDetails.rectInvDate = new Date();
        item.generalRectItemDetails.rectShipDate = new Date();
        item.rectifiedType = "R";
      }
    },

    clear() {
      this.newCarRectItemRelations = [];
      this.searchText = "";
    },

    async search(e: KeyboardEvent) {
      if (e.key != "Enter") {
        return;
      }
      this.newCarRectItemRelations = (
        await api.searchCarRectItemRelations(this.searchText, this.flowStore.invoice.partner)
      ).map((x: any) => ({ ...x, isSelected: false }));
    },

    selectItem(item: any) {
      if (!item.isSelected) {
        this.newCarRectItemRelations.forEach((e: any) => {
          e.isSelected = false;
        });
        item.isSelected = true;
      } else {
        item.isSelected = false;
      }
    },

    async addItem() {
      this.selectedCarRectItem = this.newCarRectItemRelations.find((x: any) => x.isSelected);
      if (this.selectedCarRectItem == undefined) {
        return;
      }

      await api.addCarRectItemRelation(
        this.selectedCarRectItem,
        Number(this.$route.params.invoiceId),
        Number(this.$props.invItemId)
      );

      this.newCarRectItemRelations = [];

      await this.itemStore.reloadItems();
      this.selectedCarRectItem = [];
      // this.newCarRectItemRelations = (
      //   await api.searchCarRectItemRelations(this.searchText, this.flowStore.invoice.partner)
      // ).map((x: any) => ({ ...x, isSelected: false }));
    },

    async deleteItem() {
      this.selectedCarRectItem = undefined;
      await api.deleteCarRectItemRelation(this.$props.invItemId);
    },
  },

  computed: {
    columns: () => [
      { field: "id", title: t("GENISzam") },
      { field: "type", title: t("SzamlaTipusa") },
      // { field: "invNo", title: "Bizonylat szám" },
      // { field: "name", title: "Tétel" },
      { field: "modelName", title: t("Modell"), width: "200" },
      { field: "bodyNo", title: t("Alvazszam") },
      { field: "regNum", title: t("Rendszam"), width: "90" },
      { field: "netto", title: t("Netto"), cell: "nettoTemplate", headerClassName: "right_text" },
      { field: "vat", title: t("AFA"), cell: "vatTemplate", headerClassName: "right_text" },
      { field: "brutto", title: t("Brutto"), cell: "bruttoTemplate", headerClassName: "right_text" },
      { cell: "commandTemplate", width: "60" },
      { width: 0 },
    ],
  },
});
